<template>
  <v-row dense>
    <v-col cols="12">
      <AAQuickLook :case-outputs="caseOutputs" :input-case="inputCase" :horizontal="true" />
    </v-col>
    <v-divider v-if="displayDivider" inset></v-divider>
    <v-col cols="12">
      <AADashboard :case-outputs="caseOutputs" :input-case="inputCase" :logoUrl="logoUrl" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "OutputAADashboard",
  components: {
    AAQuickLook: () => import("@/components/dashboards/AAQuickLook.vue"),
    AADashboard: () => import("@/components/dashboards/AADashboard.vue"),
  },
  mixins: [],
  props: {
    caseOutputs: { type: Object, required: true },
    inputCase: { type: Object, required: true },
    logoUrl: { type: String, required: true },
  },
  data() {
    return {};
  },
  computed: {
    displayDivider() {
      return this.$vuetify.breakpoint.smAndUp;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
